import { useEffect, useState } from 'react';
import { EMAIL_INBOX_RESOURCE } from '../api/resources';
import { createResourceSlice } from '../store/resource/createResourceSlice';
import { useApi } from '../api/components/ApiProvider';

const emailInboxesSlice = createResourceSlice({
    resource: EMAIL_INBOX_RESOURCE,
});

export const {
    indexFulfilled,
    showFulfilled,
    storeFulfilled,
    updateFulfilled,
    destroyFulfilled,

    indexEmails,
    showEmail,
    storeEmail,
    updateEmail,
    archiveEmail,
    restoreEmail,
    destroyEmail,
} = emailInboxesSlice.actions;

export const {
    selectEmailInboxById,
    makeEmailInboxesByIdsSelector,
    selectAllEmailInboxIds,
    selectAllEmailInboxes,
} = emailInboxesSlice.selectors;

export const { useEmailInboxes, useEmailInbox } = emailInboxesSlice.hooks;

// Reusable anywhere an address behind a well-known inbox slug is needed
// (e.g. the 'kundenbetreuung' inbox) - the slug stays the same across
// environments while the actual address behind it (the inbox's "name") can
// differ per environment (e.g. a test inbox on the testing server vs. the
// real one live). Resolved via the dedicated bySlug endpoint rather than
// selectAllEmailInboxes/useEmailInboxes: that list is deliberately
// restricted to active inboxes only (see #848, so retired mailboxes don't
// show up as pickable options), but some well-known inboxes (e.g.
// 'buchhaltung') are still used as a fixed address by slug even while
// marked inactive, so they need to stay resolvable here regardless.
// Returns null while loading, once no inbox with that slug exists, or on
// request failure.
export const useEmailInboxAddressBySlug = (slug) => {
    const api = useApi();
    const [address, setAddress] = useState(null);

    useEffect(() => {
        if (!slug) {
            return undefined;
        }

        let cancelled = false;
        api[EMAIL_INBOX_RESOURCE]
            .bySlug({ slug })
            .then(({ data }) => {
                if (!cancelled) {
                    setAddress(data ? data.name : null);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setAddress(null);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [api, slug]);

    return address;
};

export default emailInboxesSlice.reducer;
